import React from 'react';
import { IProps } from './types';
import commonService from 'utils/commonService';
import { IBuildingInfoFormValue } from 'constants/models/components/insureProcessFire/buildingInfo';
import { YesNo, YesNoType } from 'constants/enums/yesNo.enum';
import { BaseFireInsuredContent, BaseFirePolicyHolderContent, InprocessFillFormValue, PolicyholderKycInfo } from 'constants/models/components/insureProcessFire/insureProcessFill';
import _ from 'lodash';
// import moment from 'moment';
import moment from 'moment-timezone';
import { Marriage } from 'constants/enums/marriage.enum';
import { FireAdd, FirePlanItemBaseContent, FirePlanItemCoverageOptContent, FirePlanItemIndemnifyContent } from 'bff/models/product';
import { FireItemType } from 'constants/enums/fireItemType';
import storageService from 'utils/storageService';
import { storageKeys } from 'constants/enums/storageKeys.enum';
import environment from 'constants/environments';
import { NationalType } from 'constants/enums/nationalType.enum';
import service from 'bff/services/fireProdService';
import { OccupationIdType } from 'constants/enums/occupationIdType.enum';
import apiCommonService from 'bff/services/commonService';
import { ApplyType } from 'constants/enums/applyType.enum';
import { CodeId } from 'constants/enums/codeId.enum';
import sweetAlertService from 'utils/sweetAlertService';

class InsureProcessPreview extends React.Component<IProps> {
  componentDidMount () {
    commonService.scrollToTop();
    // console.log('temp State', JSON.stringify(this.props.tempState));
  }

  /**
   * @description 點選下一步事件
  */
  handlePreviewSubmit = async () => {
    if (this.props.tempFill.tempFillState?.applyType === ApplyType.WebRequire) {
      const isConfirm = await sweetAlertService.modal({
        title: commonService.getCodeMsg(this.props.tempState.UICodes, CodeId.W200),
        html: commonService.getCodeMsg(this.props.tempState.UICodes, CodeId.W201),
        confirmButtonText: '同意',
        cancelButtonText: '不同意',
        showCancelButton: true
      });

      if (isConfirm.dismiss) return;
    }
    const { tempBuildingInfoFormValue, tempBuildingInfoState } = this.props.tempBuildingInfo;
    const { tempSelectFormValue, tempSelectState } = this.props.tempSelect;
    const { tempFillFormValue, tempFillState } = this.props.tempFill;
    if (!tempBuildingInfoFormValue ||
      !tempBuildingInfoState ||
      !tempSelectFormValue ||
      !tempSelectState ||
      !tempFillFormValue ||
      !tempFillState
    ) return;

    let programId = storageService.getItem(storageKeys.FireProgramCode);

    if (!programId) {
      programId = environment.defaultProgramId;
    }
    const serverTimeMs = await apiCommonService.fetchSysTime();
    const req: FireAdd = {
      BC_TYPE: tempFillState.applyType,
      REPOLICY_NO: tempBuildingInfoState.renewalFire?.policyNo || '',
      APPLY_NO: tempFillState.serialNo,
      APPLY_TIME: commonService.formatUtcTime(serverTimeMs).format('YYYY-MM-DD HH:mm:ss.SSS'),
      INS_TYPE_ID: this.props.insTypeId,
      PROD_ID: tempSelectState.activeProdId,
      PLAN_ID: tempSelectState.activePlanId,
      PROGRAM_ID: programId,
      OPERATOR: tempBuildingInfoFormValue.PROGRAM_ID,
      AGREE_TIME_TERMS: commonService.formatUtcTime(tempBuildingInfoFormValue.ALL_CONTRACT_CHECKED_TIME).format('YYYY-MM-DD HH:mm:ss.SSS'),
      AGREE_TIME_UNDERINS: tempSelectState.belowItem_check_time
        ? commonService.formatUtcTime(tempSelectState.belowItem_check_time).format('YYYY-MM-DD HH:mm:ss.SSS')
        : '',
      START_HOUR: '12',
      START_DATE: moment(tempBuildingInfoFormValue.INSURED_DATE).format('YYYY-MM-DD HH:mm:ss'),
      END_DATE: moment(tempBuildingInfoFormValue.INSURED_DATE).add(1, 'y').format('YYYY-MM-DD HH:mm:ss'),
      POSTCODE: tempBuildingInfoFormValue.POST_CODE,
      CITY_ID: tempBuildingInfoFormValue.CITY_ID,
      AREA_ID: tempBuildingInfoFormValue.AREA_ID,
      ADDRESS_RD_ST: tempBuildingInfoFormValue.STREET_ID_NAME,
      ADDRESS_LN: tempBuildingInfoFormValue.ADDRESS_ROADWAY ? +tempBuildingInfoFormValue.ADDRESS_ROADWAY : undefined,
      ADDRESS_ALY: tempBuildingInfoFormValue.ADDRESS_ALLEY ? +tempBuildingInfoFormValue.ADDRESS_ALLEY : undefined,
      ADDRESS_NO: tempBuildingInfoFormValue.ADDRESS_NUMBER_OF
        ? `${tempBuildingInfoFormValue.ADDRESS_NUMBER}-${tempBuildingInfoFormValue.ADDRESS_NUMBER_OF}`
        : tempBuildingInfoFormValue.ADDRESS_NUMBER,
      ADDRESS_F: tempBuildingInfoFormValue.ADDRESS_FLOOR && tempBuildingInfoFormValue.ADDRESS_FLOOR_OF
        ? `${tempBuildingInfoFormValue.ADDRESS_FLOOR}-${tempBuildingInfoFormValue.ADDRESS_FLOOR_OF}`
        : tempBuildingInfoFormValue.ADDRESS_FLOOR
          ? tempBuildingInfoFormValue.ADDRESS_FLOOR
          : undefined,
      ADDRESS_NOTE: tempBuildingInfoFormValue.ADDRESS_REMARK,
      BUILDING_FLOOR: +tempBuildingInfoFormValue.FLOOR_TOTAL,
      BUILDING_BASEMENT: +tempBuildingInfoFormValue.BASEMENT_FLOOR_TOTAL,
      USAGE_AREA: parseFloat(Number.parseFloat(tempBuildingInfoFormValue.SQUARE_FEET).toFixed(2)),
      BUILDING_STRUCTURE: tempBuildingInfoFormValue.BUILDING_STRUCTURE,
      ROOF_STRUCTURE: tempBuildingInfoFormValue.ROOF_TYPE,
      BUILDING_YEAR: tempBuildingInfoFormValue.CONSTRUCTION_YEAR,
      COMMERCIAL_BUILDING: tempBuildingInfoFormValue.TRADE === YesNo.Yes ? '1' : '0',
      DECORATION_COST: +tempBuildingInfoFormValue.DECORATION_COST >= 10000 ? +tempBuildingInfoFormValue.DECORATION_COST / 10000 : 0,
      IS_MORTGAGE: tempFillFormValue.HAS_MORTGAGE === YesNoType.Yes && tempFillFormValue.LENDER === YesNo.Yes
        ? YesNoType.Yes
        : tempFillFormValue.HAS_MORTGAGE === YesNoType.Yes && tempFillFormValue.LENDER === YesNo.No
          ? YesNoType.No
          : YesNoType.Other,
      POLICY_DELIVERY: tempFillFormValue.DELIVERY,
      TOTAL_FEE: tempSelectState.evalFireRes.TOTAL_FEE,
      APPLICANT: this.handleGetApplicantInfos(tempFillFormValue.POLICYHOLDERS, tempFillState.serialNo),
      INSURED: this.handleGetInsuredInfos(tempFillFormValue.INSUREDS),
      ITEMS: this.handleGetPolicyItmeInfo(tempSelectFormValue.POLICY_ITEMS, tempFillState.serialNo, tempSelectState.activeProdId, tempSelectState.activePlanId),
      MORTGAGE: tempFillFormValue.LENDER === YesNo.Yes
        ? {
          APPLY_NO: tempFillState.serialNo,
          POLICY_NO: '',
          HDR_ID: tempFillFormValue.MORTGAGEE_BANK,
          HBRCH_ID: tempFillFormValue.MORTGAGEE_BANK_BRANCH,
          OPERATOR: tempFillFormValue.BANK_HANDLE_RECIPIENT,
          POSTCODE: tempFillFormValue.BANK_RECEIVING_POST_CODE,
          CITY_ID: tempFillFormValue.BANK_RECEIVING_CITY_ID,
          AREA_ID: tempFillFormValue.BANK_RECEIVING_AREA_ID,
          ADDRESS: tempFillFormValue.BANK_RECEIVING_ADDRESS,
          DELIVER_BANK: tempFillFormValue.SEND_MORTGAGEE_BANK === YesNo.Yes ? '1' : '0'
        }
        : undefined
    };

    // console.log('add req', JSON.stringify(req));
    const res = await service.addFire(req);
    if (!res) return;

    this.props.onSubmit();
  }

  /**
   * @description 取得保單新增-要保人資訊
  */
  handleGetApplicantInfos = (holders: BaseFirePolicyHolderContent[], serialNo: string) => {
    return _.map(holders, (holder: BaseFirePolicyHolderContent, index: number) => {
      const kycInfos = new Array(0);
      _.forEach(holder.POLICYHOLDER_KYC_INFOS, (kycInfo: PolicyholderKycInfo) => {
        if (kycInfo.KYC_ANSWER.KEY === '99') {
          kycInfos.push({
            APPLY_NO: serialNo,
            ASSURER_ID: holder.POLICYHOLDER_ID,
            KYC_ID: kycInfo.KYC_ID,
            KYC_ANSWER: kycInfo.KYC_ANSWER.KEY,
            KYC_OTHER: kycInfo.KYC_ANSWER.INPUT_VAL
          });
          return;
        }

        kycInfos.push({
          APPLY_NO: serialNo,
          ASSURER_ID: holder.POLICYHOLDER_ID,
          KYC_ID: kycInfo.KYC_ID,
          KYC_ANSWER: kycInfo.KYC_ANSWER.KEY,
          KYC_OTHER: ''
        });
      });

      return {
        APPLICANT_SEQ: index + 1,
        APPLICANT_ID: holder.POLICYHOLDER_ID,
        APPLICANT_ID_TYPE: holder.POLICYHOLDER_NATIONALITY_TYPE,
        APPLICANT_NAME: holder.POLICYHOLDER_NAME,
        BIRTHDAY: holder.POLICYHOLDER_BIRTHDAY
          ? moment(holder.POLICYHOLDER_BIRTHDAY).format('YYYYMMDD')
          : moment().format('YYYYMMDD'),
        MOBILE: holder.POLICYHOLDER_MOBILE,
        EMAIL: holder.POLICYHOLDER_EMAIL_ADDR,
        MARRIAGE: holder.POLICYHOLDER_MARRIAGE
          ? holder.POLICYHOLDER_MARRIAGE
          : Marriage.Single,
        POSTCODE: holder.POLICYHOLDER_POST_CODE,
        CITY_ID: holder.POLICYHOLDER_CITY_ID,
        AREA_ID: holder.POLICYHOLDER_AREA_ID,
        ADDRESS: holder.POLICYHOLDER_ADDRESS,
        OCC_DOMAIN: holder.POLICYHOLDER_OCCUPATION_DOMAIN_ID || OccupationIdType.Normal,
        OCCUPATION: holder.POLICYHOLDER_OCCUPATION_ID || '000',
        KYCS: kycInfos,
        SYNC_MBDATA: holder.UPDATE_INFO_CHECKED
      };
    });
  }

  /**
   * @description 取得保單新增-被保人資訊
  */
  handleGetInsuredInfos = (insureds: BaseFireInsuredContent[]) => {
    return _.map(insureds, (insured: BaseFireInsuredContent, index: number) => {
      return {
        INSURED_SEQ: index + 1,
        INSURED_ID: insured.INSURED_ID,
        INSURED_NAME: insured.INSURED_NAME,
        RELATIONSHIP: insured.INSURED_RELATION,
        BIRTHDAY: insured.INSURED_BIRTHDAY
          ? moment(insured.INSURED_BIRTHDAY).format('YYYYMMDD')
          : '',
        MOBILE: insured.INSURED_MOBILE,
        EMAIL: insured.INSURED_EMAIL_ADDR,
        POSTCODE: insured.INSURED_POST_CODE,
        CITY_ID: insured.INSURED_CITY_ID,
        AREA_ID: insured.INSURED_AREA_ID,
        ADDRESS: insured.INSURED_ADDRESS,
        ID_TYPE: insured.INSURED_NATIONALITY_TYPE,
        OCC_DOMAIN: insured.INSURED_OCCUPATION_DOMAIN_ID || OccupationIdType.Normal,
        OCCUPATION: insured.INSURED_OCCUPATION_ID || '000'
      };
    });
  }

  /**
   * @description 取得保單新增-保障內容資訊
  */
  handleGetPolicyItmeInfo = (policyItems: FirePlanItemBaseContent[], serialNo: string, prodId: string, planId: string) => {
    const resItems = new Array(0);
    _.forEach(policyItems, (policyItem: FirePlanItemBaseContent) => {
      if (policyItem.ITEM_OPTIONAL === FireItemType.ITEM_CHECKBOX_SHOW && !policyItem.CHECKED) return;
      _.forEach(policyItem.INDEMNIFYS, (indemnify: FirePlanItemIndemnifyContent) => {
        resItems.push({
          APPLY_NO: serialNo,
          POLICY_NO: '',
          PROD_ID: prodId,
          PLAN_ID: planId,
          ITEM_PARENT_TITLE: policyItem.ITEM_NAME,
          ITEM_PARENT_ID: policyItem.ITEM_ID,
          ITEM_TITLE: indemnify.INDEMNIFY_NAME || policyItem.ITEM_NAME, // TODO 帶調整
          ITEM_ID: indemnify.INDEMNIFY_ID,
          ITEM_OPTION: indemnify.INS_COVERAGE_OPTION ? +this.handleGetAmt(indemnify.INS_COVERAGE_OPTION) : 0,
          FEE: isNaN(+indemnify.PREMIUM) ? 0 : +indemnify.PREMIUM
        });
      });
    });

    return resItems;
  }

  /**
   * @description 取得投保金額
  */
  handleGetAmt = (opts: FirePlanItemCoverageOptContent[]) => {
    if (!opts || opts.length === 0) return 0;

    const opt = _.find(opts, (opt: FirePlanItemCoverageOptContent) => opt.TYPE !== FireItemType.TYPE_TEXT);
    if (!opt) return 0;

    switch (opt.TYPE) {
      case FireItemType.TYPE_SHOW:
        return +commonService.removeComma(`${opt.SHOW_VALUE}`);
      case FireItemType.TYPE_INPUT:
        return +commonService.removeComma(`${opt.INPUT_VALUE}`);
      case FireItemType.TYPE_OPTION:
        return opt.SELECT_VALUE;
      default:
        return 0;
    }
  }

  /**
 * @description 取得會員 ID 類別對應的顯示名稱
*/
  handleGetNationalityType = (nationalityType: string) => {
    switch (nationalityType) {
      case NationalType.Foreigner:
        return '居留證號';
      case NationalType.Legal:
        return '統一編號';
      case NationalType.National:
      default:
        return '身份證字號';
    }
  };

  render () {
    const { tempBuildingInfoFormValue } = this.props.tempBuildingInfo;
    const { tempSelectFormValue, tempSelectState } = this.props.tempSelect;
    const { tempFillFormValue, tempFillState } = this.props.tempFill;

    // #region 建築物資料區塊相關方法

    /**
     * @description 取得完整 標的物地址
    */
    const handleGetFullAddress = (values: IBuildingInfoFormValue) => {
      return commonService.getFullAddress(
        values.POST_CODE, values.CITY_NAME, values.AREA_NAME, values.STREET_ID_NAME, values.ADDRESS_ROADWAY,
        values.ADDRESS_ALLEY, values.ADDRESS_NUMBER, values.ADDRESS_NUMBER_OF, values.ADDRESS_FLOOR, values.ADDRESS_FLOOR_OF,
        values.ADDRESS_REMARK
      );
    };

    // #endregion

    // #region 建立保障內容區塊
    /**
     * @description 根據主附約建立保障內容區塊
     */
    const handleCreatePolicyItemContent = (policyItems: FirePlanItemBaseContent[]) => {
      const mainItems: any = new Array(0);
      const subItems: any = [(
        <tr key="0" className="coverage__table-sub-title">
          <th>附約</th>
          <th />
          <th />
          <th />
        </tr>
      )];

      _.forEach(policyItems, (policyItem: FirePlanItemBaseContent) => {
        if (policyItem.ITEM_SHOW === '0') return;

        switch (policyItem.ITEM_TYPE) {
          case FireItemType.ITEM_TYPE_MAIN: {
            mainItems.push(handleCreatePolicyItem(policyItem));
            break;
          }
          default: {
            subItems.push(handleCreatePolicyItem(policyItem));
            break;
          }
        }
      });

      return (
        <>
          {mainItems}
          {subItems}
        </>
      );
    };

    /**
     * @description 建立保障項目區塊
     */
    const handleCreatePolicyItem = (policyItem: FirePlanItemBaseContent) => {
      const childCount = policyItem.INDEMNIFYS.length;

      const res = new Array(0);
      for (let i = 0; i < childCount; i += 1) {
        if (policyItem.ITEM_OPTIONAL === FireItemType.ITEM_CHECKBOX_SHOW && !policyItem.CHECKED) return;
        res.push(
          <tr key={i}>
            <td>
              {
                i === 0 && policyItem.ITEM_OPTIONAL === FireItemType.ITEM_CHECKBOX_SHOW
                  ? (
                    <div className="element__checkbox-group">
                      <div className="element__checkbox">
                        <input
                          disabled
                          type="checkbox"
                          checked={policyItem.CHECKED}
                        />
                        <div className="element__checkbox-btn" />
                      </div>
                      <span>{`${policyItem.ITEM_NAME}${policyItem.ITEM_DESC || ''}`}</span>
                    </div>
                  )
                  : i === 0 ? `${policyItem.ITEM_NAME}${policyItem.ITEM_DESC || ''}` : ''
              }
            </td>
            <td>
              {
                policyItem.INDEMNIFYS[i] && policyItem.INDEMNIFYS[i].INDEMNIFY_NAME_SHOW === '1' && `${policyItem.INDEMNIFYS[i].INDEMNIFY_NAME || ''}`
              }
            </td>
            <td>
              {policyItem.INDEMNIFYS[i] && policyItem.INDEMNIFYS[i].INS_COVERAGE_SHOW === '1' && handleGetConverageInfo(policyItem.INDEMNIFYS[i].INS_COVERAGE_OPTION)}
            </td>
            <td>{commonService.thousandFormat(`${policyItem.INDEMNIFYS[i].PREMIUM}`)}</td>
          </tr>
        );
      }
      return res;
    };

    /**
     * @description 取得保險金額內容
    */
    const handleGetConverageInfo = (opts: FirePlanItemCoverageOptContent[]) => {
      if (!opts || opts.length === 0) return '';

      const opt = _.find(opts, (opt: FirePlanItemCoverageOptContent) => opt.TYPE !== FireItemType.TYPE_TEXT);
      if (!opt) return '';

      switch (opt.TYPE) {
        case FireItemType.TYPE_SHOW:
          return commonService.thousandFormat(`${opt.TEXT}`);
        case FireItemType.TYPE_INPUT:
          return commonService.thousandFormat(`${opt.INPUT_VALUE}` || '0');
        case FireItemType.TYPE_OPTION:
          return opt.SELECT_TEXT;
      }
    };

    // #endregion

    // #region 建立要保人資訊區塊

    const handleCreatePolicyholderInfo = (policyholders: BaseFirePolicyHolderContent[]) => {
      return _.map(policyholders, (holder: BaseFirePolicyHolderContent, index: number) => {
        return (
          <div className="element__list" key={index}>
            <div className="element__list-col">
              <div className="element__list-group">
                <div className="element__list-group-title">要保人姓名</div>
                <div className="element__list-group-content">{holder.POLICYHOLDER_NAME}</div>
              </div>
            </div>
            <div className="element__list-col">
              <div className="element__list-group">
                <div className="element__list-group-title">{this.handleGetNationalityType(holder.POLICYHOLDER_NATIONALITY_TYPE)}</div>
                <div className="element__list-group-content">{holder.POLICYHOLDER_ID}</div>
              </div>
            </div>
            {
              holder.POLICYHOLDER_NATIONALITY_TYPE !== NationalType.Legal && (
                <>
                  <div className="element__list-col">
                    <div className="element__list-group">
                      <div className="element__list-group-title">出生年月日</div>
                      <div className="element__list-group-content">{moment(holder.POLICYHOLDER_BIRTHDAY).format('YYYY年MM月DD日')}</div>
                    </div>
                  </div>
                  <div className="element__list-col">
                    <div className="element__list-group">
                      <div className="element__list-group-title">婚姻狀況</div>
                      <div className="element__list-group-content">
                        {
                          holder.POLICYHOLDER_MARRIAGE === Marriage.Married ? '已婚' : '未婚'
                        }
                      </div>
                    </div>
                  </div>
                </>
              )
            }
            <div className="element__list-col">
              <div className="element__list-group">
                <div className="element__list-group-title">手機號碼</div>
                <div className="element__list-group-content">{holder.POLICYHOLDER_MOBILE}</div>
              </div>
            </div>
            <div className="element__list-col">
              <div className="element__list-group">
                <div className="element__list-group-title">電子信箱</div>
                <div className="element__list-group-content">{holder.POLICYHOLDER_EMAIL_ADDR}</div>
              </div>
            </div>
            <div className="element__list-col">
              <div className="element__list-group">
                <div className="element__list-group-title">通訊地址</div>
                <div className="element__list-group-content">
                  {
                    `${holder.POLICYHOLDER_POST_CODE} ${holder.POLICYHOLDER_CITY_NAME}${holder.POLICYHOLDER_AREA_NAME}${holder.POLICYHOLDER_ADDRESS}`
                  }
                </div>
              </div>
            </div>
            <div className="element__list-col">
              <div className="element__list-group">
                <div className="element__list-group-title">要保人繳交保險費之資金來源</div>
                <div className="element__list-group-content">
                  {
                    holder.POLICYHOLDER_KYC_INFOS && holder.POLICYHOLDER_KYC_INFOS.length > 0 && (
                      _.map(holder.POLICYHOLDER_KYC_INFOS, (kycInfo: PolicyholderKycInfo) => {
                        if (kycInfo.KYC_ANSWER.KEY === '99') {
                          return `${kycInfo.KYC_ANSWER.TEXT} : ${kycInfo.KYC_ANSWER.INPUT_VAL}`;
                        }
                        return kycInfo.KYC_ANSWER.TEXT;
                      })
                    )
                  }
                </div>
              </div>
            </div>
          </div>
        );
      });
    };

    // #endregion

    // #region 建立被保人資訊區塊

    const handleCreateInsuredInfo = (insureds: BaseFireInsuredContent[]) => {
      return _.map(insureds, (insured: BaseFireInsuredContent, index: number) => {
        return (
          <div className="element__list" key={index}>
            <div className="element__list-col">
              <div className="element__list-group">
                <div className="element__list-group-title">與要保人關係</div>
                <div className="element__list-group-content">{insured.INSURED_RELATION_NAME}</div>
              </div>
            </div>
            <div className="element__list-col">
              <div className="element__list-group">
                <div className="element__list-group-title">被保險人</div>
                <div className="element__list-group-content">{insured.INSURED_NAME}</div>
              </div>
            </div>
            <div className="element__list-col">
              <div className="element__list-group">
                <div className="element__list-group-title">{this.handleGetNationalityType(insured.INSURED_NATIONALITY_TYPE)}</div>
                <div className="element__list-group-content">{insured.INSURED_ID}</div>
              </div>
            </div>
            {
              insured.INSURED_NATIONALITY_TYPE !== NationalType.Legal && (
                <div className="element__list-col">
                  <div className="element__list-group">
                    <div className="element__list-group-title">出生年月日</div>
                    <div className="element__list-group-content">{insured.INSURED_BIRTHDAY ? moment(insured.INSURED_BIRTHDAY).format('YYYY年MM月DD日') : ''}</div>
                  </div>
                </div>
              )
            }
            <div className="element__list-col">
              <div className="element__list-group">
                <div className="element__list-group-title">手機號碼</div>
                <div className="element__list-group-content">{insured.INSURED_MOBILE}</div>
              </div>
            </div>
            <div className="element__list-col">
              <div className="element__list-group">
                <div className="element__list-group-title">電子信箱</div>
                <div className="element__list-group-content">{insured.INSURED_EMAIL_ADDR}</div>
              </div>
            </div>
            <div className="element__list-col">
              <div className="element__list-group">
                <div className="element__list-group-title">通訊地址</div>
                <div className="element__list-group-content">
                  {
                    `${insured.INSURED_POST_CODE} ${insured.INSURED_CITY_NAME}${insured.INSURED_AREA_NAME}${insured.INSURED_ADDRESS}`
                  }
                </div>
              </div>
            </div>
          </div>
        );
      });
    };

    // #endregion

    // #region 建立抵押權人資訊區塊

    const handleCreateMortgageInfo = (formVal: InprocessFillFormValue) => {
      return (
        <>
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">抵押權人</div>
              <div className="element__list-group-content">
                {`${formVal.MORTGAGEE_CODE} ${formVal.MORTGAGEE_BANK_NAME}`}
              </div>
            </div>
          </div>
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">保單正本及收據副本是否寄送抵押銀行</div>
              <div className="element__list-group-content">
                {
                  formVal.SEND_MORTGAGEE_BANK === YesNo.Yes
                    ? '是'
                    : formVal.SEND_MORTGAGEE_BANK === YesNo.No
                      ? '否'
                      : ''
                }
              </div>
            </div>
          </div>
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">銀行經辦收件人</div>
              <div className="element__list-group-content">
                {formVal.BANK_HANDLE_RECIPIENT}
              </div>
            </div>
          </div>
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">銀行收件地址</div>
              <div className="element__list-group-content">
                {
                  `${formVal.BANK_RECEIVING_POST_CODE} ${formVal.BANK_CITY_NAME}${formVal.BANK_AREA_NAME}${formVal.BANK_RECEIVING_ADDRESS}`
                }
              </div>
            </div>
          </div>
        </>
      );
    };

    // #endregion

    return (
      <div className="insure-process-preview">
        <div className="insure-process-preview__content">
          {/* 保障範圍 */}
          <div className="coverage">
            <div className="coverage__title">保障範圍</div>
            <div className="coverage__content">
              {
                tempBuildingInfoFormValue && tempSelectFormValue && tempSelectState && (
                  <>
                    <table className="coverage__table">
                      <tbody>
                        <tr className="coverage__table-title">
                          <th>商品</th>
                          <th>保障內容</th>
                          <th>保險金額</th>
                          <th>保險費</th>
                        </tr>
                        {
                          handleCreatePolicyItemContent(tempSelectFormValue.POLICY_ITEMS)
                        }
                      </tbody>
                    </table>
                    <div className="coverage__row">
                      <div className="coverage__effective-date">
                        <p>{`預定生效日：${moment(tempBuildingInfoFormValue.INSURED_DATE).format('YYYY年MM月DD日')}中午12時起，保期一年`}</p>
                      </div>
                      <div className="coverage__premium">
                        <p>{`保費合計：NT$ ${commonService.thousandFormat(`${tempSelectState.evalFireRes.TOTAL_FEE}`)} 元`}</p>
                      </div>
                    </div>
                  </>
                )
              }
            </div>
          </div>
          {/* 建築物資料 */}
          <div className="building-info">
            {
              tempBuildingInfoFormValue && (
                <>
                  <div className="building-info__title">建築物資料</div>
                  <div className="building-info__content">
                    <div className="element__list">
                      <div className="element__list-col">
                        <div className="element__list-group">
                          <div className="element__list-group-title">標的物地址</div>
                          <div className="element__list-group-content">{handleGetFullAddress(tempBuildingInfoFormValue)}</div>
                        </div>
                      </div>
                      <div className="element__list-col">
                        <div className="element__list-group">
                          <div className="element__list-group-title">總樓層數</div>
                          <div className="element__list-group-content">
                            {`地上層共${tempBuildingInfoFormValue.FLOOR_TOTAL}層 地下層共${tempBuildingInfoFormValue.BASEMENT_FLOOR_TOTAL}層；所在樓層第${tempBuildingInfoFormValue.CURRENT_FLOOR}層`}
                          </div>
                        </div>
                      </div>
                      <div className="element__list-col">
                        <div className="element__list-group">
                          <div className="element__list-group-title">使用面積(含公設)</div>
                          <div className="element__list-group-content">
                            {`${+tempBuildingInfoFormValue.SQUARE_FEET}坪`}
                          </div>
                        </div>
                      </div>
                      <div className="element__list-col">
                        <div className="element__list-group">
                          <div className="element__list-group-title">建築物結構</div>
                          <div className="element__list-group-content">
                            {tempBuildingInfoFormValue.BUILDING_STRUCTURE_NAME}
                          </div>
                        </div>
                      </div>
                      <div className="element__list-col">
                        <div className="element__list-group">
                          <div className="element__list-group-title">屋頂別</div>
                          <div className="element__list-group-content">
                            {tempBuildingInfoFormValue.ROOF_TYPE_NAME}
                          </div>
                        </div>
                      </div>
                      <div className="element__list-col">
                        <div className="element__list-group">
                          <div className="element__list-group-title">建造年份</div>
                          <div className="element__list-group-content">
                            {`民國${+tempBuildingInfoFormValue.CONSTRUCTION_YEAR}年`}
                          </div>
                        </div>
                      </div>
                      <div className="element__list-col">
                        <div className="element__list-group">
                          <div className="element__list-group-title">同棟樓是否有營業</div>
                          <div className="element__list-group-content">
                            {
                              tempBuildingInfoFormValue.TRADE === YesNo.Yes ? '是' : '否'
                            }
                          </div>
                        </div>
                      </div>
                      <div className="element__list-col">
                        <div className="element__list-group">
                          <div className="element__list-group-title">裝潢費用</div>
                          <div className="element__list-group-content">
                            {`${tempBuildingInfoFormValue.DECORATION_COST_NAME}/坪`}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )
            }
          </div>
          {/* 要保人資料 */}
          <div className="policyholder-info">
            {
              tempFillFormValue && (
                <>
                  <div className="policyholder-info__title">
                    <span>要保人資料</span>
                  </div>
                  <div className="policyholder-info__content">
                    {
                      tempFillFormValue && tempFillFormValue.POLICYHOLDERS.length > 0 && handleCreatePolicyholderInfo(tempFillFormValue.POLICYHOLDERS)
                    }
                  </div>
                </>
              )
            }
          </div>
          {/* 被保險人資料 */}
          <div className="insured-info">
            {
              tempFillFormValue && (
                <>
                  <div className="insured-info__title">被保險人資料</div>
                  <div className="insured-info__content">
                    {
                      tempFillFormValue.INSUREDS && tempFillFormValue.INSUREDS.length > 0 && handleCreateInsuredInfo(tempFillFormValue.INSUREDS)
                    }
                  </div>
                </>
              )
            }
          </div>
          {/* 抵押權資料 */}
          <div className="mortgage-info">
            {
              tempFillFormValue && tempFillFormValue.LENDER === YesNo.Yes && (
                <>
                  <div className="mortgage-info__title">抵押權資料</div>
                  <div className="mortgage-info__content">
                    <div className="element__list">
                      {
                        tempFillFormValue && handleCreateMortgageInfo(tempFillFormValue)
                      }
                    </div>
                  </div>
                </>
              )
            }
          </div>
          {/* 保單寄送方式 */}
          <div className="delivery">
            <div className="delivery__title">保單寄送方式</div>
            <div className="delivery__content">
              <div className="element__list">
                <div className="element__list-col">
                  <div className="element__list-group">
                    <div className="element__list-group-title">保單寄送方式</div>
                    <div className="element__list-group-content">
                      {
                        tempFillFormValue && tempFillState && commonService.getSysOptText(tempFillState.policyDeliverySysOpts, tempFillFormValue.DELIVERY)
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="insure-process-preview__controls">
          <button type="button" className="element__button element__button--red-border" onClick={this.props.onGoBack}>返回上一頁</button>
          <button type="button" className="element__button element__button--red" onClick={this.handlePreviewSubmit}>下一步</button>
        </div>
      </div>
    );
  }
}

export default InsureProcessPreview;
